<template>
  <div class="page-table-fprm-all">
    <a-form
      layout="inline"
      :form="form"
      @submit="handleSubmit"
      class="page-form-queryheder"
    >
      <!-- <a-form-item :label="$tc('lang.orderAll.Order_Type')">
        <a-select
          style="width: 120px"
          @change="handleChange"
          :placeholder="$tc('lang.orderAll.Select_the_order_type')"
          v-decorator="['orderType']"
          allowClear
        >
          <a-select-option value="1">{{
            $tc('lang.menuGoodsSpace.Mid_Term_Inspection')
          }}</a-select-option>
          <a-select-option value="2">{{
            $tc('lang.menuGoodsSpace.Final_Inspection')
          }}</a-select-option>
          <a-select-option value="3">{{
            $tc('lang.menuGoodsSpace.Fabric_Inspection')
          }}</a-select-option>
          <a-select-option value="4">{{
            $tc('lang.menuGoodsSpace.Factory_Evaluation')
          }}</a-select-option>
          <a-select-option value="5">{{
            $tc('lang.menuGoodsSpace.Vendor_Assessment')
          }}</a-select-option>
          <a-select-option value="6">{{
            $tc('lang.menuList.Loading_Supervision')
          }}</a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item :label="$tc('lang.orderAll.Service_Date')">
        <a-date-picker
        style="width: 140px"

          @change="onDateChange"
          :placeholder="$tc('lang.orderAll.Select_the_date')"
          v-decorator="['dateTime']"
        />
      </a-form-item>
      <!-- <a-form-item :label="$tc('lang.orderAll.Order_status')">
        <a-select
          style="width: 180px"
          @change="handleChange"
          :placeholder="$tc('lang.orderAll.Select_the_order_status')"
          v-decorator="['orderStatus']"
          allowClear
        >
          <a-select-option value="9">{{
            $tc('lang.orderAll.Finished')
          }}</a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item :label="$tc('lang.orderAll.Vendor_name')">
        <a-input
        style="width: 120px"

          v-decorator="['vendorName']"
          :placeholder="$tc('lang.orderAll.Vendor_name')"
        >
        </a-input>
      </a-form-item>
      <a-form-item :label="$tc('lang.orderAll.PO_Number')">
        <a-input
        style="width: 120px"

          v-decorator="['productOrderId']"
          :placeholder="$tc('lang.orderAll.PO_Number')"
        >
        </a-input>
      </a-form-item>
      <a-form-item :label="$tc('lang.orderAll.Product_Name')">
        <a-input
        style="width: 120px"

          v-decorator="['productNames']"
          :placeholder="$tc('lang.orderAll.Product_Name')"
        >
        </a-input>
      </a-form-item>
      <a-form-item :label="$tc('lang.orderAll.Item_Number')">
        <a-input
        style="width: 120px"

          v-decorator="['itemNumbers']"
          :placeholder="$tc('lang.orderAll.Item_Number')"
        >
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit">
          {{ $tc('lang.orderAll.search') }}
        </a-button>
      </a-form-item>
    </a-form>
    <a-table
      :columns="columns"
      :dataSource="data"
      :scroll="{ x: 1500, y: 485 }"
      style="
         width: 97%;
         margin: 20px;
        border: 1px solid #dbdbdb"
      :customRow="clickHang"
      :pagination="{
        total: total,
        current: page,
        pageSize: size,
        onChange: onChangePage,
      }"
    >
      <span slot="actionOne" slot-scope="record">
        <a-button
          type="primary"
          size="small"
          v-if="
              record.orderState == '8' ||
              record.orderState == '9'
          "
          style="
        display: inline-block;
        margin-right: 5px;
        background: #FF8D1A;
        border: 1px solid #FF8D1A"
          @click.stop
          @click="queryReportList(record)"
          >{{ $tc('lang.orderAll.down_Report') }}</a-button
        >
      </span>
      <span slot="orderServicedate" slot-scope="text, record">{{
        $momentData(record.orderServicedate)
      }}</span>
      <span slot="orderDate" slot-scope="text, record">{{
        $momentData(record.orderDate)
      }}</span>
      <span slot="orderServicechargeusd" slot-scope="text, record"
        >${{
          record.orderServicechargeusd === null
            ? 0
            : record.orderServicechargeusd
        }}/¥{{
          record.orderServicechargermb === null
            ? 0
            : record.orderServicechargermb
        }}</span
      >
    </a-table>
    <start-from ref="startFrom" />
  </div>
</template>
<script>
import startFrom from '../../views/downOrder/componentsGd/startFrom';
import moment from 'moment';
// 已经完成
// const columns = ;

// 已完成订单
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      data: [],
      columns: [
        {
          title: this.$tc('lang.orderAll.Serial_Number'),
          align: 'center',
          width: 60,
          fixed: 'left',
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: this.$tc('lang.orderAll.Order_Number'),
          dataIndex: 'orderId',
          key: 'orderId',
          width: 300,
          align: 'center',
        },
        {
          title: this.$tc('lang.orderAll.Service_Date'),
          key: 'orderServicedate',
          dataIndex: 'orderServicedate',
          width: 70,
          align: 'center',
          scopedSlots: { customRender: 'orderServicedate' },
        },
        {
          title: this.$tc('lang.orderAll.Vendor_name'),
          width: 140,
          align: 'center',
          dataIndex: 'orderFactoryname',
          key: 'orderFactoryname',
        },
        {
          title: this.$tc('lang.orderAll.PO_Number'),
          width: 140,
          align: 'center',
          dataIndex: 'productOrderId',
          key: 'productOrderId',
        },
        // {
        //   title: this.$tc('lang.orderAll.Order_date'),
        //   dataIndex: 'setmealName',
        //   key: 'setmealName',
        //   width: 120,
        //   align: 'center',
        //   scopedSlots: { customRender: 'orderDate' },
        // },
        {
          title: this.$tc('lang.orderAll.Product_Name'),
          dataIndex: 'productnames',
          key: 'productnames',
          width: 120,
          align: 'center'
        },
        {
          title: this.$tc('lang.orderAll.Item_Number'),
          dataIndex: 'itemnumbers',
          key: 'itemnumbers',
          width: 120,
          align: 'center'
        },
        
        {
          title: this.$tc('lang.orderAll.Service_fee'),
          key: 'orderServicechargeusd',
          dataIndex: 'orderServicechargeusd',
          scopedSlots: { customRender: 'orderServicechargeusd' },
          width: 80,
          align: 'center',
        },
      
        {
          title: this.$tc('lang.orderAll.Order_status'),
          width: 80,
          key: 'orderState',  
          dataIndex: 'orderState',
          align: 'center',
          customRender: (text, record, index) => {
            if (text === '0') {
              return this.$tc('lang.orderAll.To_be_confirmed');
            } else if (text === '1') {
              return this.$tc('lang.orderAll.To_be_paid');
            } else if (text === '2') {
              return this.$tc('lang.orderAll.To_be_assigned');
            } else if (text === '3') {
              return this.$tc('lang.orderAll.Order_release');
            } else if (text === '4') {
              return this.$tc('lang.orderAll.To_be_served');
            } else if (text === '5') {
              return this.$tc('lang.orderAll.Under_inspecting');
            } else if (text === '6') {
              return this.$tc('lang.orderAll.Under_auditing');
            } else if (text === '7') {
              return this.$tc('lang.orderAll.To_be_translated');
            } else if (text === '8') {
              return this.$tc('lang.orderAll.To_be_reviewed');
            } else if (text === '9') {
              return this.$tc('lang.orderAll.Finished');
            } else if (text === '999999') {
              return record;
            } else if (text === '000000') {
              return index;
            }
          },
        },
        
        {
          title: this.$tc('lang.orderAll.Operate'),
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'actionOne' },
          // width: '14%',
          align: 'center',
          visible: false,
          condition: true,
        },
      ],
      page: 1,
      size: 10,
      total: 10,
      loading: true,
      orderData: {},
      user: {},
      dateTime: '',
    };
  },
  created() {
    this.queryOrder();
  },
  // 数据状态处理全局
  computed: {
    // 快速下单表单提交的数据
    goodsDataList: {
      get() {
        return this.$store.state.downOrder.goodsDataList;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          goodsDataList: value,
        });
      },
    },
  },
  components: {
    'start-from': startFrom,
  },
  methods: {
     /*查看报告编号*/
     queryReportList(value) {
      // this.add()
      this.$router.push({
        path: '/reportManage',
        query: {
          id: value.orderId,
        },
      });
    },
    // 整行点击事件
    clickHang(record, index) {
      const _this = this;
      return {
        on: {
          click: () => {
            this.$http
              .post('/hzwmj/workorder/selectById', {
                id: record.id,
              })
              .then(data => {
                if (data != null) {
                  const reastData = data.data;
                  const workorder = reastData.workorder;
                  const medias = reastData.medias;
                  const products = reastData.products;
                  console.log('workorder=====', workorder);
                  console.log('medias=====', medias);
                  console.log('products=====', products);
                  // 图片回显
                  let fileArray = [];
                  if (medias !== null) {
                    if (medias.length !== 0) {
                      medias.forEach(value => {
                        const urlPath = this.config.urlImg + value.mediaPath;
                        fileArray.push({
                          uid: value.id,
                          name: value.mediaName,
                          url: urlPath,
                          status: 'done',
                        });
                      });
                    }
                  }
                  let foProduct = [];
                  if (products.length !== 0) {
                    products.forEach(value => {
                      foProduct.push({
                        productName: value.productName,
                        productModelid: value.productModelid,
                        orderId: value.productOrderid,
                        productCount: value.productCount,
                        productUnit: value.productUnit,
                      });
                    });
                  }
                  _this.goodsDataList = {
                    formDataMap: {
                      // 工厂信息
                      orderFactoryname: workorder.orderFactoryname,
                      orderFactoryarea:
                        workorder.orderFactoryarea !== null
                          ? workorder.orderFactoryarea.split('/')
                          : [],
                      orderFactoryaddress: workorder.orderFactoryaddress,
                      orderFactoryperson: workorder.orderFactoryperson,
                      orderFactoryfixedtel: workorder.orderFactoryfixedtel,
                      orderFactorytel: workorder.orderFactorytel,
                      orderFactoryemail: workorder.orderFactoryemail,
                      // 我的信息
                      orderTrustcompany: workorder.orderTrustcompany,
                      orderTrustaddress: workorder.orderTrustaddress,
                      orderTrustperson: workorder.orderTrustperson,
                      orderTrustfixedtel: workorder.orderTrustfixedtel,
                      orderTrusttel: workorder.orderTrusttel,
                      orderTrustemail: workorder.orderTrustemail,
                      //验货时间
                      orderServicedate:
                        workorder.orderServicedate != null
                          ? moment(workorder.orderServicedate)
                          : null,
                      //检验水平
                      aql: workorder.orderLevel,
                      //致命缺陷
                      criterion: workorder.orderFataldefect,
                      //严重缺陷
                      serious: workorder.orderSeriousdefect,
                      //轻微缺陷
                      slight: workorder.orderMinordefect,
                      // 客户要求
                      orderRequire: workorder.orderRequire,
                    },
                    // 图片回显
                    fileList: {
                      fileArray: fileArray,
                    },
                    // 产品数据
                    tableDataList: foProduct,
                    modelType: true,
                  };
                  console.log('_this.goodsDataList=====', _this.goodsDataList);
                  console.log(_this);
                  _this.$refs.startFrom.init();
                }
              })
              .catch(() => {
                console.log('12313');
              });
            // this.$refs.startFrom.init();
            console.log('record=====', record);
            console.log('index=====', index);
          },
        },
      };
    },
    // 条件查询
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
          this.orderData = {
            productOrderId: values.productOrderId === undefined ? '' : values.productOrderId,
            productNames:
              values.productNames === undefined ? '' : values.productNames,
              itemNumbers:
              values.itemNumbers === undefined ? '' : values.itemNumbers,
              vendorName:
              values.vendorName === undefined ? '' : values.vendorName,
          };
          this.queryOrder(this.orderData);
        }
      });
    },
    //立即支付
    action(record) {
      console.log(record);
      // this.$nextTick(() => {
      //   this.$refs.PayModal.init(100);
      // });
    },
    /*下拉*/
    handleChange(value) {
      // this.add()
      console.log(`selected ${value}`);
    },
    /*检验时间*/
    onDateChange(date, dateString) {
      console.log(date, dateString);
      this.dateTime = dateString;
    },
    // 切换页码
    onChangePage(page) {
      this.page = page;
      this.queryOrder();
    },
    // 表格请求
    queryOrder() {
      console.log('=====日期=====', this.dateTime);
      if (sessionStorage.getItem('user') !== null) {
        this.user = JSON.parse(sessionStorage.getItem('user')) || {};
      }
      this.$http
        .post('/hzwmj/workorder/getOrderPageList', {
          page: this.page,
          size: this.size,
          orderStatus:
            this.orderData.orderStatus === undefined
              ? '8,9'
              : this.orderData.orderStatus,
              productOrderId: this.orderData.productOrderId,
          vendorName: this.orderData.vendorName,
          productNames: this.orderData.productNames,
          itemNumbers: this.orderData.itemNumbers,
          dateTime: this.dateTime,
          personId: this.user.id,
        })
        .then(data => {
          if (data.code === 200) {
            const buyData = data.data;
            this.data = buyData.records;
            this.total = buyData.total;
            this.loading = false;
          } else if (data.code === 900) {
            this.$message.error(data.msg);
          } else {
            this.$message.error('系统异常');
          }
        })
        .catch(() => {
          this.data = [];
          this.total = 0;
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less">
.page-table-fprm-all {
  padding-top: 10px;
  padding-bottom: 40px;
  border-left: 3px solid #f0f2f5;
  border-right: 2px solid #f0f2f5;
  border-bottom: 2px solid #a7a7a7;
  border-radius: 10px;
  margin-top: 3%;
  .page-form-queryheder {
    border-radius: 10px;
    border-bottom: 2px solid #a2a2a2;
    border-left: 1px solid #dbdbdb;
    border-right: 1px solid #dbdbdb;
    width: 97%;
    margin: 20px;
  }
}
</style>
